"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArticlesSectionSkeleton = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _lodash = _interopRequireDefault(require("lodash.times"));
var _react = require("react");
var _styles = require("../ArticlesSection/styles");
var _TitleSkeleton = require("../TitleSkeleton");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Renders Skeleton for `ArticlesSection`.
 */ const ArticlesSectionSkeleton = (param)=>{
    let { animation = 'pulse', className, mode, showTitle } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const countOfArticles = (0, _react.useMemo)(()=>mode === 'listing' ? 12 : 6, [
        mode
    ]);
    const articles = (0, _react.useMemo)(()=>(0, _lodash.default)(countOfArticles).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.ArticleBoxSkeleton, {
                animation: animation
            }, "".concat(_presentationComponents.ARTICLE_BOX_SKELETON, "-").concat(index))), [
        animation,
        countOfArticles
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        className: className,
        "data-testid": getTestId(_constants.ARTICLES_SECTION_SKELETON),
        children: [
            showTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_TitleSkeleton.TitleSkeleton, {
                animation: animation
            }) : null,
            mode === 'listing' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Articles, {
                children: articles
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.CarouselSkeleton, {
                children: articles
            }),
            mode === 'listing' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.PaginationSkeleton, {
                animation: animation
            }) : null
        ]
    });
};
exports.ArticlesSectionSkeleton = ArticlesSectionSkeleton;
